<div class="grid expired-token-container full-height-grid">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content pl-6 mt-6">
    <div class="col-12">
      <h2 class="link-Expired">{{ 'Auth.Unauthorized' | translate }}</h2>
      <br />
      <span class="large-paragraph link-message">
        {{ 'Auth.UnauthorizedDescription' | translate }}
      </span>
      <br />
      <p-button [label]="'Header.Logout' | translate"
        styleClass="p-button-rounded"
        class="p-2"
        (onClick)="onLogoutClicked()" />
    </div>

    <div class="col-12 p-0">
      <app-language-selector />
    </div>
  </div>
</div>
